module.exports = __webpack_public_path__ + "static/media/hexagonStylingLeft.938f5136.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Projects/Assets/hexagonStylingLeft.svg
// module id = 511
// module chunks = 1